// Libraries
import {
  Component,
  OnInit
} from '@angular/core';
import {
  Router
} from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

// Services
import { Angular2TokenService, UserData } from 'angular2-token';

/**
 * `NavbarComponent` implements the navigation bar.
 */
@Component({
  selector: 'she-navbar',
  template: require('./navbar.component.html'),
  styles: [require('./navbar.component.scss')]
})
export class NavbarComponent implements OnInit {
  /**
   * Store if sidebar is collapsed or not.
   */
  public isSidebarCollapsed = false;
  /**
   * Current user information.
   */
  public loggedUser: UserData;

  /**
   * Creates a new `NavbarComponent` instance.
   * @param tokenService Service to communicate with the api
   * @param router Router object
   * @param toastr Show notification
   */
  constructor(
    private tokenService: Angular2TokenService,
    private router: Router,
    private toastr: ToastsManager
  ) {}

  /**
   * Implements on init method
   */
  public ngOnInit() {
   this.tokenService.validateToken().subscribe(
      () => {
        // Save current user information
        this.loggedUser = this.tokenService.currentUserData;
      }
    );
  }

  /**
   * Close user session.
   */
  public logout(): any {
    // Do logout and redirect to login path
    this.tokenService.signOut().subscribe(
      () => {
        // Redirect to login
        this.router.navigate(['/login']);
        // Show message
        this.toastr.success('Se ha deslogueado correctamente.', 'Éxito!');
      },
      () => {
        // Redirect to login
        this.router.navigate(['/login']);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/layout/navbar/navbar.component.ts